module.exports = __webpack_public_path__ + "static/media/XRP.639b151a.svg";